"use client";

import React from "react";
import styles from "./blessnet-unavailable-modal.module.scss";
import BlessModal from "@/components/layout/modal/bless-modal";
import BlessButton from "@/components/layout/button/green-outline-btn";
import { RiErrorWarningLine } from "react-icons/ri";

interface BlessnetUnavailableModalProps {
  isOpen: boolean;
  onClose: () => void;
}

/**
 * Modal component that displays when bridging to Blessnet is unavailable
 * due to insufficient BLESS balance on the parent chain
 */
const BlessnetUnavailableModal: React.FC<BlessnetUnavailableModalProps> = ({
  isOpen,
  onClose,
}) => {
  return (
    <BlessModal open={isOpen} onCancel={onClose}>
      <div className={styles.modalContent}>
        <div className={styles.iconWrapper}>
          <RiErrorWarningLine className={styles.warningIcon} />
        </div>

        <h2 className={styles.title}>Bridging to Blessnet Currently Unavailable</h2>

        <div className={styles.message}>
          <p>
            We&apos;re temporarily unable to bridge to Blessnet.
          </p>
          <p>
            Please contact us for assistance or try again later.
          </p>
        </div>

        <div className={styles.actions}>
          <BlessButton
            buttonType="outlined"
            color="white"
            onClick={() => window.open('mailto:support@blessnet.com', '_blank')}
            styles={{ flex: 1 }}
          >
            Contact Support
          </BlessButton>
          <BlessButton
            buttonType="solid"
            onClick={onClose}
            styles={{ flex: 1 }}
          >
            Close
          </BlessButton>
        </div>
      </div>
    </BlessModal>
  );
};

export default BlessnetUnavailableModal;
